export function usePictureUrl(model, size = 'xlarge') {
  const { attributes: { picture } = {} } = model;
  const { file_data, [size]: pictureUrl = '' } = picture || {};

  return pictureUrl || (typeof file_data === 'string' && file_data.length > 0 ? file_data : null);
}
